export default __webpack_public_path__ + "static/media/sante.4e44224b.png";